import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import lodashMemoize from 'lodash/memoize';
import SearchBoxDropdown from '@adsk/bim360-matrix-react-search-box-dropdown';
import i18n from '../../utils/i18n';
import {createSearchQuery, stripSearchQuery} from '../../utils/query-helpers';
import {COLLECTION_TYPES, TEMPLATES_FILTER_PROPERTIES} from '../../constants/issue-query-params';
import {templatesQueryParamsType} from '../../constants/proptype-validation';
import {TEMPLATE_FIELD_NAMES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES} from '../../constants/issue-templates';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';

class TemplatesSearchDropdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchExpression: stripSearchQuery(props.queryParams[TEMPLATES_FILTER_PROPERTIES.SEARCH])
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.queryParams[TEMPLATES_FILTER_PROPERTIES.SEARCH] !==
      this.props.queryParams[TEMPLATES_FILTER_PROPERTIES.SEARCH]
    ) {
      const nextSearchExpression = stripSearchQuery(nextProps.queryParams[TEMPLATES_FILTER_PROPERTIES.SEARCH]);
      if (nextSearchExpression !== this.state.searchExpression) {
        this.setState({searchExpression: nextSearchExpression});
      }
    }
  }

  onSearch = searchExpression => {
    this.setState({searchExpression});
    const searchQuery = searchExpression ? createSearchQuery(searchExpression) : '';
    this.props.setQueryParamsAction({[TEMPLATES_FILTER_PROPERTIES.SEARCH]: searchQuery}, COLLECTION_TYPES.TEMPLATES);
  };

  getSearchSuggestedSearchResults = searchExpression => {
    this.setState({searchExpression});
    if (searchExpression) {
      const searchQuery = createSearchQuery(searchExpression);
      this.props.getTemplatesSearchResultsAction(searchQuery);
    } else {
      this.props.clearTemplatesSearchResultsAction();
    }
  };

  handleSuggestedClick = template => {
    const {changeLocationAction} = this.props;
    changeLocationAction(`project/${TYPE_QUALITY_ISSUES}/templates/${template.id}`);
  };

  getSuggestionList = lodashMemoize(templatesSearchResults =>
    templatesSearchResults.map(template => ({
      ...template,
      title: template[TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES][TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE]
    }))
  );

  render() {
    const {templatesSearchResults} = this.props;
    const {searchExpression} = this.state;
    return (
      <SearchBoxDropdown
        className="TemplatesSearchDropdown"
        placeholder={i18n.t('search')}
        searchExpression={searchExpression}
        onSearch={this.onSearch}
        searchForSuggestedResults={this.getSearchSuggestedSearchResults}
        onSuggestedResultRowSelect={this.handleSuggestedClick}
        suggestionList={this.getSuggestionList(templatesSearchResults)}
      />
    );
  }
}

TemplatesSearchDropdown.displayName = 'TemplatesSearchDropdown';

TemplatesSearchDropdown.propTypes = {
  queryParams: templatesQueryParamsType.isRequired,
  templatesSearchResults: PropTypes.array,
  getTemplatesSearchResultsAction: PropTypes.func.isRequired,
  clearTemplatesSearchResultsAction: PropTypes.func.isRequired,
  setQueryParamsAction: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired
};

export default TemplatesSearchDropdown;
